"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import {
//     AnyFunctionSchema,
//     FunctionSurveyCreateSchema,
//     FunctionJokeCreateSchema,
// } from './functionCallSchema';
// export type FunctionSurveyCreateObject = TypeOf<typeof FunctionSurveyCreateSchema>;
// export type FunctionJokeCreateObject = TypeOf<typeof FunctionJokeCreateSchema>;
// export type AnyFunctionCallObject = TypeOf<typeof AnyFunctionSchema>;
//# sourceMappingURL=functionCallModel.js.map